import { render, staticRenderFns } from "./page_header_mobile.vue?vue&type=template&id=21a06b8d&scoped=true"
import script from "./page_header_mobile.vue?vue&type=script&lang=js"
export * from "./page_header_mobile.vue?vue&type=script&lang=js"
import style0 from "./page_header_mobile.vue?vue&type=style&index=0&id=21a06b8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a06b8d",
  null
  
)

export default component.exports